import PropTypes from 'prop-types';
import React, {Component} from 'react';

//helpers
import {styleable} from 'decorators';
import {unpackCssShorthand} from 'utils/css-utils';
import {rem} from 'utils/dom-utils';

@styleable
class ResponsiveFontSizeComponent extends Component {
  static defaultProps = {
    baseWidth: 0,
    minFontSize: rem(1),
    minPadding: 0
  };

  static propTypes = {
    // Lowest width for the the font size and padding to start growing:
    baseWidth: PropTypes.number,

    // Starting font size:
    minFontSize: PropTypes.number,

    // Starting padding
    minPadding: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),

    // A function to be called with the computed fontSize/padding
    // combination. When not provided, applies the styles on itself
    onResize: PropTypes.func
  };

  componentDidMount() {
    const {baseWidth, minFontSize, minPadding, onResize = this.handleResize} = this.props;
    const {clientWidth} = this.ref;

    const multiplier = Math.max(1, clientWidth / baseWidth);

    const padding = unpackCssShorthand(minPadding).map(padding => Math.round(padding * multiplier));

    onResize({
      fontSize: Math.round(minFontSize * multiplier),
      paddingTop: padding[0],
      paddingRight: padding[1],
      paddingBottom: padding[2],
      paddingLeft: padding[3]
    });
  }

  handleResize = style => {
    for (const prop in style) {
      this.ref.style[prop] = `${style[prop]}px`;
    }
  };

  render() {
    const {children, dangerouslySetInnerHTML} = this.props;
    if (children) {
      return <div children={children} ref={ref => (this.ref = ref)} />;
    }
    return <div dangerouslySetInnerHTML={dangerouslySetInnerHTML} ref={ref => (this.ref = ref)} />;
  }
}

export default ResponsiveFontSizeComponent;
